import { Box, Container, Group } from '@mantine/core';
import { ToolbarLogo } from './PublicToolbar';
import { useSmallerView } from '@/hooks/useSmallerView';
import { TranslationSelector } from '@/pages/Translation/TranslationSelector';

interface ToolbarProps {
  preLeft?: React.ReactNode;
  left?: React.ReactNode;
  center?: React.ReactNode;
  right: React.ReactNode;
}

export function Toolbar({ preLeft, left, center, right }: ToolbarProps) {
  const isMobile = useSmallerView('sm');
  const langSelector = <TranslationSelector />;

  return (
    <Box bg="accent">
      <Container size="xl" w="100%">
        <Group h={56} justify="space-between" wrap="nowrap" gap={0}>
          <Group gap={2} wrap="nowrap" pr="lg">
            {preLeft}
            <ToolbarLogo />
            {left}
          </Group>
          {!isMobile && center && (
            <Group flex={1} justify="center" mx="md">
              {center}
              {langSelector}
            </Group>
          )}
          <Group justify="end" wrap="nowrap">
            {right}
          </Group>
        </Group>
        {isMobile && center && (
          <Group pb="xs" justify="center">
            {center}
            {langSelector}
          </Group>
        )}
      </Container>
    </Box>
  );
}
